import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-approve-recruiters',
  templateUrl: './approve-recruiters.component.html',
  styleUrls: ['./approve-recruiters.component.scss']
})
export class ApproveRecruitersComponent implements OnInit {
  
  companies: Array<any> = [];
  cnpj: string = '';
  cnpjSearched = false;
  
  displayedColumns: string[] = ['businessname', 'cnpj', 'email', 'phone', 'approve', 'action'];
  
  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  searchCompany() {
    if (!this.cnpj) {
      return;
    }

    this.http.get('company:getCnpj', {cnpj: this.cnpj})
      .subscribe(
        (result: any) => {
          this.companies = [result.data];
          this.cnpjSearched = true;
        },
        err => this.errorReport.showMessage(err)
      )

  }

  verifyCompany(email:string, number:number){
    
    let message: string;

    if (number === 1) {
      message = 'Deseja realmente Aprovar essa Empresa?';
    } else {
      message = 'Deseja realmente Reprovar essa Empresa?';
    }

    if (!confirm(message))
      return;

    this.http.get('company:approve', {email:email , approve:number})
      .subscribe(
        (result: any) => {
          if (result.type === 'OK' && number === 1) {
            this.snackbar.open('Empresa Aprovada com sucesso !!!', 'OK', { duration: 3000 });
          }else{
            this.snackbar.open('Empresa Reprovada com sucesso !!!', 'OK', { duration: 3000 });
          }
          this.searchCompany();
        },
        err => this.errorReport.showMessage(err)
      )

  }

  validateNumberInput(event: KeyboardEvent) {
    const input = event.key;
    // Permite apenas números
    if (!/^\d+$/.test(input)) {
      event.preventDefault();
    }
  }

}
